module.exports = __webpack_public_path__ + "img/content4.c0f0b3cc.png";